<template>
    <JackpotBlock
        v-if="isJackpotEnabled"
        v-bind:matchCount="displayEventsCount"
        v-bind:countBgColor="countBgColor"
    />

    <div v-else class="matchesSectionHeader">
        <div class="matchesSectionHeader-inner">
            <SvgIcon
                name="icon-system-e-football"
                size="lg"
            />
            <div class="matchesSectionHeader-content">
                <span class="matchesSectionHeader-label">{{ eFootballText }}</span>
                <Count
                    v-bind:number="displayEventsCount"
                    v-bind:bgColor="countBgColor"
                    v-bind:textColor="'white'"
                />
            </div>
            <img
                v-bind:src="decoRectangle"
                alt=""
            />
        </div>
    </div>
</template>

<script lang="ts" setup>
    import { storeToRefs } from 'pinia';
    import { computed } from 'vue';
    import decoRectangle from '@/assets/images/tournamentCenter/TournamentCenterDecoRectangle.svg';
    import Count from '@/components/common/Count.vue';
    import SvgIcon from '@/components/common/SvgIcon.vue';
    import JackpotBlock from '@/components/jackpot/JackpotBlock.vue';
    import { i18n } from '@/core/lib/i18n';
    import { SiteStyle } from '@/interface/enum';
    import { useToggleStore } from '@/store/toggleStore';

    const props = defineProps<{
        displayEventsCount: number;
        isLive: boolean;
    }>();

    const { isJackpotEnabled } = storeToRefs(useToggleStore(SiteStyle.Asia));

    const eFootballText = computed(() => i18n.t('promotion_zone_2'));

    const countBgColor = computed(() => (props.isLive ? 'live' : 'nonLive'));
</script>

<style lang="scss" scoped>
    @import "@/views/tournamentCenter/EFootballBlock";
</style>
